module.exports = __webpack_public_path__ + "assets/icon-vegetationHeight-high.5cb8cb79.svg";